import roleFavouriting from './roleFavouriting';

export default class {

    constructor() {      
        this.roleFavouriting = new roleFavouriting();
    }

}
